import { observer } from 'mobx-react-lite';
import { CalendarItemPeekCallout } from 'owa-calendar-peek-callout';
import * as React from 'react';
import type { Target } from '@fluentui/react/lib/Callout';
import { SpacesCalendarAssetEntrySource } from '../constants';
import { useCalendarEventsPeekCalloutState } from '../hooks/useCalendarEventsPeekCalloutState';
import { useRepositionableCallout } from 'owa-react-hooks/lib/useRepositionableCallout';

/**
 * Props for item peek renderer
 */
export interface CalendarEventPeekCalloutProps {
    target: Target | undefined;
    onDismissed: () => void;
}

/**
 * Component for rendering item peek
 */
export default observer(function CalendarEventPeekCallout(props: CalendarEventPeekCalloutProps) {
    const { onDismissed, target } = props;

    const {
        onOpenEventClicked,
        onReviewProposedNewTimeClicked,
    } = useCalendarEventsPeekCalloutState(props);

    const {
        onMouseDown,
        onPositioned,
        calloutStyles,
        manuallyRepositioned,
    } = useRepositionableCallout();

    return target ? (
        <CalendarItemPeekCallout
            target={target}
            onOpenEventClicked={onOpenEventClicked}
            onReviewProposedNewTimeClicked={onReviewProposedNewTimeClicked}
            viewType={SpacesCalendarAssetEntrySource}
            entrySource={'SpacesCalendarAsset'}
            onDismissed={onDismissed}
            onPositioned={onPositioned}
            styles={calloutStyles}
            onMouseDown={onMouseDown}
            beakWidth={manuallyRepositioned ? 0 : undefined} // if repositioned manually, hide the beak
        />
    ) : null;
});
